<section class="centered-with-padding pb-12 pt-7">
  <div class="grid grid-cols-1 gap-x-3 gap-y-5 desk:grid-cols-2">
    @for (inset of data.insets; track $index) {
      <a class="drop-shadow-custom block rounded-2xl bg-anis p-5" [routerLink]="inset.url">
        <div class="grid h-full grid-cols-[1fr_auto] items-center gap-x-6">
          <div class="h-full">
            <app-title [title]="{ text: inset.title, as: 'span' }" size="custom-25" />
            <div class="mt-3">{{ inset.text }}</div>
          </div>
          <app-svg [height]="17" [width]="23" src="assets/icons/arrow-right.svg" />
        </div>
      </a>
    }
  </div>
</section>
